import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_USER_DATA: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/info`).then(res => {
        commit('SET_USER', res.body)
        commit('SET_ROLES', [res.body.role])
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  USERS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_USER: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/export`, { user_id: userId }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_USERS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/export-many`, {}, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_USERS: ({ commit, dispatch }, userIds) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/delete`, { user_ids: userIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ACTIVATE_USER: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/${userId}`, { action: 'alternative_activate' }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  RESET_USER_PERMISSIONS: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/${userId}`, { action: 'remove_overridden_permissions' }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  INVITE_USER: ({ commit, dispatch }, email) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/invite`, { email: email }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_USER: ({ commit, dispatch }, {userId, newData}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/users/${userId}`, newData).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  REGISTERD_USERS_CHART: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/registrations-chart`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ACTIVE_USERS_CHART: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/active-users-chart`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js